import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { JVDate } from "../../../shared/JVDate";
import { JVDropdown } from "../../../shared/JVDropdown";
import { Button } from "primereact/button";
import { Fetch } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { useRef } from "react";
export interface IUSFilter {
  fromDate?: Date | null;
  ToDate?: Date | null;
  company_Type?: string | null;
  company_ID?: number | null;
  company_Group_ID?: number | null;
}

export const EmptyRecRepFilter: IUSFilter = {
  fromDate: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
  ToDate: new Date(),
  company_Type: null,
  company_ID: null,
  company_Group_ID: null,
};

interface Iprops {
  filter: IUSFilter;
  setFilter: (filter: IUSFilter) => void;
  setGroupName: (groupName: string | null) => void;
}

const Company_Type = [{ name: "-- SELECT --" }, { name: "Company Wise" }, { name: "Company Group Wise" }];

export const Filter = (props: Iprops) => {
  const [companies, setCompanies] = useState<Array<any>>([]);
  const [companyGroups, setCompanyGroups] = useState<Array<{ id: null; groupName: "-- SELECT --" }>>([]);

  const { control, handleSubmit, reset, watch, setValue } = useForm<IUSFilter>({
    defaultValues: props.filter ?? EmptyRecRepFilter,
    shouldFocusError: false,
  });

  const selectedCompanyType = watch("company_Type");
  const fromDate = watch("fromDate");

  const maxToDate = fromDate ? new Date(Math.min(new Date(fromDate).getTime() + 30 * 24 * 60 * 60 * 1000, new Date().getTime())) : new Date();

  const loadCompanies = async () => {
    const response = await Fetch("Dropdown/companyListForHRs", "GET", null, null, null);
    if (response) {
      const data: Array<any> = await response.json();
      data.unshift({ company_ID: null, company_Name: "-- SELECT --" });
      setCompanies(data);
    }
  };

  const loadCompanyGroups = async () => {
    const response = await Fetch("Dropdown/getCompanyGroup", "GET", null, null, null);
    if (response) {
      const data: Array<any> = await response.json();
      data.unshift({ id: null, groupName: "-- SELECT --" });
      setCompanyGroups(data);
    }
  };

  useEffect(() => {
    if (selectedCompanyType === "Company Wise") {
      loadCompanies();
    } else if (selectedCompanyType === "Company Group Wise") {
      loadCompanyGroups();
    }
  }, [selectedCompanyType]);

  const toast = useRef<any>(null);

  function onSubmit(data: IUSFilter) {
    if (data.fromDate && data.ToDate) {
      const diffMs = new Date(data.ToDate).getTime() - new Date(data.fromDate).getTime();
      const diffDays = diffMs / (1000 * 60 * 60 * 24);
      if (diffDays > 30) {
        toast.current.show({ severity: "error", content: "Date range cannot exceed 30 days." });
        return;
      }
      if (diffDays < 0) {
        toast.current.show({ severity: "error", content: "To Date cannot be before From Date." });
        return;
      }
    }

    if (data.company_Type === "Company Wise") {
      data.company_Group_ID = null;
    } else if (data.company_Type === "Company Group Wise") {
      data.company_ID = null;
    } else {
      data.company_ID = null;
      data.company_Group_ID = null;
    }
    props.setFilter(data);
  }

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "company_Type") {
        if (value.company_Type !== undefined && value.company_Type !== null && value.company_Type === "Company Wise") {
          setValue("company_Group_ID", null);
          props.setGroupName(null);
        } else if (value.company_Type !== undefined && value.company_Type !== null && value.company_Type === "Company Group Wise") {
          setValue("company_ID", null);
        } else {
          setValue("company_ID", null);
          setValue("company_Group_ID", null);
        }
      }

      if (name === "company_Group_ID") {
        if (value.company_Group_ID !== undefined && value.company_Group_ID !== null && value.company_Group_ID !== 0) {
          props.setGroupName(companyGroups.find((el) => el.id === value.company_Group_ID)?.groupName || null);
        }
      }
    });

    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch, companyGroups, props.setGroupName]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
      <JVDate maxDate={new Date()} column={6} label="From Date" control={control} name="fromDate" />
      <JVDate maxDate={maxToDate} minDate={fromDate ?? undefined} column={6} label="To Date" control={control} name="ToDate" />
      <JVDropdown column={6} label="Company Type" control={control} name="company_Type" options={Company_Type} optionLabel="name" optionValue="name" placeholder="Select Company Type" />
      {selectedCompanyType === "Company Wise" && <JVDropdown column={6} label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />}
      {selectedCompanyType === "Company Group Wise" && <JVDropdown column={6} label="Company Group" control={control} name="company_Group_ID" options={companyGroups} optionLabel="groupName" optionValue="id" placeholder="Select Company Group" />}
      <div className="col-12 md:col-12" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "10px" }}>
        <Button label="SEARCH" type="submit" />
        <Button
          className="p-button-outlined"
          label="CLEAR"
          type="button"
          onClick={() => {
            reset(EmptyRecRepFilter);
          }}
        />
      </div>
      <Toast ref={toast} />
    </form>
  );
};
